"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _wdh = require("@demant/wdh");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var withReactBootstrap = function withReactBootstrap(Component) {
  var HOC = /*#__PURE__*/function (_React$Component) {
    _inherits(HOC, _React$Component);

    var _super = _createSuper(HOC);

    _createClass(HOC, null, [{
      key: "resolveDesktop",
      value: function resolveDesktop() {
        return window.matchMedia(_constants.MOBILE_BREAK_POINT).matches;
      }
    }]);

    function HOC(props) {
      var _this;

      _classCallCheck(this, HOC);

      _this = _super.call(this, props);
      _this.state = {
        isDesktop: HOC.resolveDesktop(),
        isScrolled: window.pageYOffset > 0,
        pageScrollOffset: window.pageYOffset
      };
      return _this;
    }

    _createClass(HOC, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        (0, _wdh.onResize)(function () {
          _this2.updateDesktopState();
        });
        (0, _wdh.onScroll)(function (offset) {
          _this2.updateScrollState(offset);

          _this2.updateIfPageIsScrolled(offset);
        });
      }
    }, {
      key: "updateDesktopState",
      value: function updateDesktopState() {
        this.setState({
          isDesktop: HOC.resolveDesktop()
        });
      }
    }, {
      key: "updateScrollState",
      value: function updateScrollState(offset) {
        this.setState({
          pageScrollOffset: offset
        });
      }
    }, {
      key: "updateIfPageIsScrolled",
      value: function updateIfPageIsScrolled(offset) {
        this.setState({
          isScrolled: offset > 0
        });
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, this.state));
      }
    }]);

    return HOC;
  }(_react["default"].Component);

  return HOC;
};

var _default = withReactBootstrap;
exports["default"] = _default;